import { ImageName } from "@mcleod/images";
import { LayoutProvidedReportDecoratorProps, PanelProps, ReportPreview, ReportViewerTab } from "@mcleod/components";

export class BackOfficeReportPreview extends ReportPreview {
    constructor(title: string, visible: boolean = true) {
        const reportProps: Partial<LayoutProvidedReportDecoratorProps> = {
            reportPreviewTitle: title,
            tabCreationCallback: (tab: ReportViewerTab) => {
                tab.imageName = ImageName.document;
                tab.headingImage.rowBreak = false;
                tab.headingImage.tooltip = tab.reportData.reportName;
            },
        };
        const panelProps: Partial<PanelProps> = {
            fillHeight: true,
            fillRow: true,
            visible
        };
        super(reportProps, panelProps);
    }
}
